// extracted by mini-css-extract-plugin
export var labelWrapper = "_gg-0";